import React from 'react'
import { Button } from '@material-ui/core'

function ButtonLink({ text, onClick }) {
   return (
      <Button color="primary" fullWidth onClick={onClick}>
         {text}
      </Button>
   )
}

export default ButtonLink
